import { Component, OnInit, ViewEncapsulation, Inject, Input  } from '@angular/core';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import {NgForm} from '@angular/forms';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import { Friends} from '../../../modele/user/userModel';
import {RelationService} from "../../../services/relation/relation.service";


@Component({
  selector: 'app-friends-from-user',
  templateUrl: './friends-from-user.component.html',
  styleUrls: ['./friends-from-user.component.scss']
})
export class FriendsFromUserComponent implements OnInit {
    friendsList: Friends[] = [];
    searchValue = new FormControl();
    filteredStates: Observable<Friends[]>;
    userLen;
    friendsListLength: number;
    friendsCount: number;
    value;
    _filterLen;


    constructor(
        private router: Router,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        private bottomSheet: MatBottomSheet,
        private relationService: RelationService,

    ) {
        this.getFriends();
        this.filteredStates = this.searchValue.valueChanges.pipe(
            startWith(''),
            map(user => user ? this._filterStates(user) : this.friendsList.slice())
        );

    }
    private _filterStates(value: string): Friends[] {
        const filterValue = value.toLowerCase();
        this.userLen = this.friendsList.length - this.friendsList.filter(user => user.user_name.toLowerCase().indexOf(filterValue)).length;
        return this.friendsList.filter(user => user.user_name.toLowerCase().indexOf(filterValue) === 0);
    }

    ngOnInit(): void {

    }
    onSubmitSuche(f: NgForm) {
    this.router.navigate(["/", this.searchValue.value]);
    }
    closeBottomSheet(){
        this.bottomSheet.dismiss();
    }
    getFriends(){
        this.friendsList = [];
        this.data['data'].map(friendData=>{
            let followerList = new Friends(
                friendData.user_id,
                friendData.user_name,
                friendData.user_avatar,
                friendData.message,
                friendData.relation_status,
                friendData.created_at,
                friendData.modifieds_at,
            )
            this.friendsList.push(followerList)
        })
        this.friendsListLength = this.friendsList.length;
    }
    deleteRelationRequest(user_id){
        this.relationService.deleteRelationRequest(user_id).subscribe(data=>{
            this.bottomSheet.dismiss();
        })
    }

}
